import React from 'react';
import {useSpring, animated} from 'react-spring'

type Props = {
    color: string;
    active: boolean;
}

type TransformConfig = {
    top: string;
    center: string;
    bottom: string;
}

export default (props: Props) => {
    const {color, active} = props;

    const openedTransformationConfig: TransformConfig = {
        top: 'translate(0, 0) rotate(0)',
        center: 'translate(0, 7) rotate(0)',
        bottom: 'translate(0, 14) rotate(0)',
    }
    
    const closedTransformationConfig: TransformConfig = {
        top: 'translate(5, 0) rotate(45)',
        center: 'translate(3, 17) rotate(-45)',
        bottom: 'translate(5, 0) rotate(45)',
    }


    // Burger = to X animation
    const { top, center, bottom } = useSpring({
        to: active ? closedTransformationConfig : openedTransformationConfig,
    })

    return <svg width="100%" height="100%" viewBox="0 0 25 18" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <animated.path style={{fill: color}} transform={top} d="M0,1.139c0.179,-0.759 1.644,-1.139 4.396,-1.139c2.751,0 9.521,0.38 20.31,1.139l0.028,1.082c0.224,1.019 -1.849,1.529 -6.22,1.529c-4.371,0 -10.542,-0.51 -18.514,-1.529l0,-1.082Z" />
        <animated.path style={{fill: color}} transform={center} d="M0,1.139c0.179,-0.759 1.644,-1.139 4.396,-1.139c2.751,0 9.521,0.38 20.31,1.139l0.028,1.082c0.224,1.019 -1.849,1.529 -6.22,1.529c-4.371,0 -10.542,-0.51 -18.514,-1.529l0,-1.082Z" />
        <animated.path style={{fill: color}} transform={bottom} d="M0,1.139c0.179,-0.759 1.644,-1.139 4.396,-1.139c2.751,0 9.521,0.38 20.31,1.139l0.028,1.082c0.224,1.019 -1.849,1.529 -6.22,1.529c-4.371,0 -10.542,-0.51 -18.514,-1.529l0,-1.082Z" />
    </svg>
}